export default __webpack_public_path__ + "static/media/advice.77ad7911.svg";